<div style="display:show" id="divdata">
    <div class="col-lg-3 col-md-3 float-left">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'orgName' | translate}}"
                   [(ngModel)]="orgData.orgName" maxlength="250">
        </div>
    </div>
    <div class="col-lg-3 col-md-3 float-left">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'orgCode' | translate}}"
                   [(ngModel)]="orgData.orgUnitCode" maxlength="250">
        </div>
    </div>
    <div class="col-lg-4 col-md-4 float-left">
        <div class="form-group">
            <label> {{'orgType' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="orgTypeModel" name="orgTypeModel"
                   [source]="orgTypeObservableSource.bind(this)"
                   [value-formatter]="orgTypeFormatter" [list-formatter]="autoCompleteListOrgTypeFormatter"
                   value-property-name="id"
                   display-property-name="orgUnitTypeName" placeholder="{{'typeChooseOrgType' | translate}}"
                   class="form-control"
                   (valueChanged)="gotNewValue($event,'orgType')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" required>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 float-left">
        <label for="sup">{{'headOfUnit' | translate}}</label>
        <div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0">
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="primarySupervisorModel"
                   name="primarySupervisorModel"
                   [source]="primarySupervisorObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id" display-property-name="displayName"
                   placeholder="{{'typeChooseHOU' | translate}}"
                   class="form-control" (valueChanged)="gotNewValue($event,'primary')" [accept-user-input]=false
                   blank-option-text="Select"
                   [no-match-found-text]="warning" id="sup" max-num-list=5>
            <span class="info-text"> {{'headOfUnit' | translate}} </span>
        </div>
    </div>

    <div class="col-lg-3 col-md-3 float-left">
        <label for="hrSpoc">{{'hrSpoc' | translate}}</label>
        <div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0">
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="hrSpocModel" name="hrSpocModel"
                   [source]="hrrObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeChooseHrSpoc' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event,'hrSpoc')"
                   [accept-user-input]=false blank-option-text="Select" [no-match-found-text]="warning" id="hrSpoc"
                   max-num-list=5>
            <span class="info-text">{{'hrSinglePointOfCont' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-4 col-md-4 float-left">
        <label for="ccAdmin">{{'ccAdmin' | translate}}</label>
        <div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0">
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="ccAdmin" name="ccAdmin"
                   [source]="hrrObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeChooseCcAdmin' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event,'ccAdmin')"
                   [accept-user-input]=false blank-option-text="Select" [no-match-found-text]="warning" id="ccAdmin"
                   max-num-list=5>
            <span class="info-text">{{'ccAdmin' | translate}}</span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 float-left">
        <label for="ccManager">{{'ccManager' | translate}}</label>
        <div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0">
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="ccManager" name="ccManager"
                   [source]="hrrObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeChooseCcManager' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event,'ccManager')"
                   [accept-user-input]=false blank-option-text="Select" [no-match-found-text]="warning" id="ccManager"
                   max-num-list=5>
            <span class="info-text">{{'ccManager' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 float-left">
        <label for="leaveAdministrator">{{'leaveAdministrator' | translate}}</label>
        <div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0">
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="leaveAdministrator" name="leaveAdministrator"
                   [source]="hrrObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeChooseLeaveAdministrator' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event,'leaveAdministrator')"
                   [accept-user-input]=false blank-option-text="Select" [no-match-found-text]="warning"
                   id="leaveAdministrator" max-num-list=5>
            <span class="info-text">{{'leaveAdministrator' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 float-left">
        <button class="btn btn-primary float-left mt-4" (click)=saveOrgData()> {{'add' | translate}}</button>
        <button class="btn btn-secondary float-left mt-4 ml-1" (click)="closeInputs()"> {{'cancel' | translate}}
        </button>

    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/org/addOrganization.html